import { createContext, ReactNode } from 'react'

// Create the context
export const BillingPaymentsHeaderSlotContext = createContext<{
    setSlot: (node: ReactNode) => void
    slot: ReactNode
}>({
    setSlot: () => {},
    slot: null,
})
